import gql from 'graphql-tag';

const activateOnboardingQueueGroupMutation = gql`
  mutation ActivateOnboardingQueueGroup($input: ActivateOnboardingQueueGroupInput!) {
    activateOnboardingQueueGroup(input: $input) {
      success
      errors
      onboardingQueueGroupAction {
        totalCount
        successCount
        skippedCount
        failureCount
        results {
          flatRateOfferId
          dealer5Mil
          outcome
          success
          status
          message
        }
      }
    }
  }
`;

export default activateOnboardingQueueGroupMutation;
